/** Units that can represent a distance */
export type IkeUnitDistance =
	| typeof IkeUnitDistance.FEET
	| typeof IkeUnitDistance.METER
	| typeof IkeUnitDistance.CENTIMETER
	| typeof IkeUnitDistance.MILLIMETER
	| typeof IkeUnitDistance.INCH;

export const IkeUnitDistance = {
	FEET: 'feet' as const,
	METER: 'meters' as const,
	CENTIMETER: 'centimeters' as const,
	MILLIMETER: 'millimeters' as const,
	INCH: 'inches' as const,
};

export type IkeImageMeasurementUnits = typeof IkeUnitDistance.FEET | typeof IkeUnitDistance.METER;

/** Units that can represent an angle */
export type IkeUnitAngle = typeof IkeUnitAngle.RADIAN | typeof IkeUnitAngle.DEGREE;

export const IkeUnitAngle = {
	RADIAN: 'radians' as const,
	DEGREE: 'degrees' as const,
};

/** Type of measurement units either an angles (radians, degrees) or distance (feet, meters,...) */
export type IkeUnits = IkeUnitAngle | IkeUnitDistance;

/** Supported types of units, Distance, Area or Angle */
export const IkeUnitType = {
	DISTANCE: 'distance' as const,
	AREA: 'area' as const,
	ANGLE: 'angle' as const,
};
export type IkeUnitType = typeof IkeUnitType.DISTANCE | typeof IkeUnitType.AREA | typeof IkeUnitType.ANGLE;
